"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelCard = function FuelCard() {
  return _react2.default.createElement(
    "g",
    { id: "fuel-card" },
    _react2.default.createElement("path", {
      d: "M19,5H5C3.3,5,2,6.3,2,8v8c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3V8C22,6.3,20.7,5,19,5z M4,8c0-0.6,0.4-1,1-1h14    c0.6,0,1,0.4,1,1v1H4V8z M20,16c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1v-5h16V16z",
      id: "Shape",
      transform: "scale(22.5)"
    })
  );
};

exports.default = FuelCard;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/FuelCard.js
// module id = 2958
// module chunks = 4